import React from 'react';

function ResultItem({data, index}) {
  const className = index % 2 === 0 ? 'stat-item result light' : 'stat-item result';

  return <div className={className}>
    <div className="result-info">
      <p className="info">{data['line_name']} <b>{data['events']['event_name']}</b></p>
    </div>
  </div>
}

export default ResultItem;